<template>
  <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
    <el-form>
      <div class="dialog-select" v-if="type === 'waitApprove' && handleType === '02'">
        <!-- 服务商 -->
        <el-row class="content-row" v-show="canSupplier">
          <el-col :span="5"><i style="color:#C8102D;font-weight:700;margin-right:3px">*</i>选择服务商</el-col>
          <el-col :span="9">
            <el-select v-model="approvalFormData.vendorId" placeholder="请选择服务商" size="small" clearable filterable style="width: 350px">
              <el-option v-for="item in vendorList" :key="item.supplierId" :label="item.supplierName" :value="item.supplierId" />
            </el-select>
          </el-col>
        </el-row>

        <!-- 预算 -->
        <div class="budget-select" v-show="canBudget">
          <!-- <el-row class="block-radio content-row">
            <el-radio-group v-model="budgetType" @change="budgetTypeChange">
              <el-radio :label="0">TR预算</el-radio>
              <el-radio :label="1">其它预算</el-radio>
            </el-radio-group>
          </el-row> -->

          <el-row class="content-row">
            <el-col :span="5"><i style="color:#C8102D;font-weight:700;margin-right:3px">*</i>{{ budgetType ? '其它预算' : 'TR预算' }}</el-col>
            <el-col :span="19">
              <!-- tr预算 -->
              <el-select v-show="!budgetType" v-model="trCode" placeholder="请选择TRcode" size="small" clearable filterable style="width: 350px" @change="trChange">
                <el-option v-for="item in trList" :key="item.trKhCode" :label="`${item.trKhCode}`" :value="item.trKhCode" />
              </el-select>
              <!-- 其它预算 -->
              <el-select v-show="budgetType" v-model="approvalFormData.quotaId" placeholder="请选择预算" size="small" clearable filterable style="width: 350px">
                <el-option v-for="item in budgetList" :key="item.quotaDTO.quotaId" :label="item.quotaDTO.quotaName" :value="item.quotaDTO.quotaId" />
              </el-select>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="5"><i style="color:#C8102D;font-weight:700;margin-right:3px">*</i>MMR12</el-col>
            <el-col :span="19">
              <el-select v-model="approvalFormData.mmr12" placeholder="请选择MMR12" size="small" clearable filterable style="width: 350px" @change="mmr12Change">
                <el-option v-for="item in mmrList" :key="item.mmr12Code" :label="item.mmr12Name" :value="item.mmr12Code" />
              </el-select>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="5">
              <i style="color:#C8102D;font-weight:700;margin-right:3px">*</i>所属工厂
            </el-col>
            <el-col :span="19">
              <el-select 
                v-model="approvalFormData.companyEntityCode" 
                placeholder="请选择所属工厂" 
                size="small" 
                clearable 
                filterable 
                style="width: 350px"
                @change="handleCompanyChange"
              >
                <el-option 
                  v-for="item in companyList" 
                  :key="item.entityCode" 
                  :label="item.title" 
                  :value="item.entityCode" 
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="5"><i style="color:#C8102D;font-weight:700;margin-right:3px">*</i>成本中心</el-col>
            <el-col :span="19">
              <el-select v-model="approvalFormData.costCenterCode" placeholder="请选择成本中心" size="small" clearable filterable style="width: 350px">
                <el-option v-for="item in costList" :key="item.costCenterCode" :label="item.costCenterName" :value="item.costCenterCode" />
              </el-select>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="5"><i style="color:#C8102D;font-weight:700;margin-right:3px">*</i>总账科目</el-col>
            <el-col :span="19">
              <el-select v-model="approvalFormData.ledgerAccount" placeholder="请选择总账科目" size="small" clearable filterable style="width: 350px">
                <el-option v-for="item in ledgerList" :key="item.ledgerAccountCode" :label="`${item.ledgerAccountCode} - ${item.ledgerAccountName}`" :value="item.ledgerAccountCode" />
              </el-select>
            </el-col>
          </el-row>
          <el-row class="content-row">
            <el-col :span="5"><i style="color:#C8102D;font-weight:700;margin-right:3px">*</i>业务月份</el-col>
            <el-col :span="19">
              <el-date-picker value-format="yyyy-MM" style="width:350px;" v-model="approvalFormData.budgetMonth" type="month"
                  placeholder="选择月" size="mini" :picker-options="pickerMothOptions">
                </el-date-picker>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 理由 -->
      <el-row class="content-row content-remark" v-if="type !== 'waitAccept'">
        <el-col :span="5" style="margin-top:5px"><i v-if="handleType === '03'" style="color:#C8102D;font-weight:700;margin-right:3px">*</i>{{handleType === '03' ? '填写驳回理由' : '填写审批建议'}}</el-col>
        <el-col :span="19">
          <el-input type="textarea" v-model="approvalFormData.processRemark" :placeholder="handleType === '03' ? '请填写驳回理由' : '请填写审批建议'" style="width: 350px"></el-input>
        </el-col>
      </el-row>
      <el-row v-else class="content-row" style="text-align: center; font-size: 16px">是否确认收货？</el-row>
      <div style="margin-top:10px;" v-if="showAcceptTip">注意：店招物料类提报验收成功后将触发PR审批和PO创建流程。</div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="btn-red-plain" size="small" @click="closeDialog">取 消</el-button>
      <el-button v-if="handleType === '03'" class="btn-red" size="small" :loading="btnLoading" @click="handleBatchReject">确认驳回</el-button>
      <el-button v-else class="btn-red" size="small" :loading="btnLoading" @click="handleBatchPass">确认{{ dialogTitle }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: ['approvalFormData', 'btnLoading'],
  data () {
    return {
      reasonValue: '',
      dialogVisible: false,
      type: '',
      handleType: '',
      dialogTitle: '',

      vendorList: [],
      budgetType: 0,
      budgetList: [],
      trList: [],
      mmrList: [],
      ledgerList: [],
      companyList: [],
      costList: [],

      applyId: '',

      canSupplier: false,
      canBudget: false,
      trCode: '',
      pickerMothOptions: {
        disabledDate: (time) => {
          const beginDate = new Date().getTime()
          if(beginDate > time.getTime()){
            return  parseTime(beginDate,'{y}-{m}-{d}') !== parseTime(time,'{y}-{m}-{d}')
          }else{
            return false
          }
        },
      },
      showAcceptTip:false

    }
  },
  methods: {
    showDialog (type, val, id, canSupplier, canBudget, vendorCode) {
      this.type = type
      this.handleType = val
      this.applyId = id
      this.canSupplier = canSupplier
      this.canBudget = canBudget
      this.setTitle()

      if(this.type === 'waitCheck' && this.handleType === '02'){
        this.showAcceptTip = true
      }

      if (this.type === 'waitApprove' && this.handleType === '02') {
        this.getSupplier()
        this.getBudgetList()
        this.getTrList()
        this.getMmrList()
        if (vendorCode) {
          this.getCompanyList(vendorCode)
        }
      }
      
      this.dialogVisible = true
    },

    closeDialog () {
      Object.assign(this.$data, this.$options.data())
      this.dialogVisible = false
      this.showAcceptTip = false
    },

    // 设置标题
    setTitle () {
      if (this.handleType === '03') {
        this.dialogTitle = '驳回'
      } else {
        if (this.type === 'waitApprove') this.dialogTitle = '通过'
        if (this.type === 'waitCheck') this.dialogTitle = '验收'
        if (this.type === 'waitAccept') this.dialogTitle = '收货'
      }
    },

    // 获取供应商列表
    getSupplier () {
      const params = {
        vendorName: ''
      }
      this.$store.dispatch('getSupplier', params).then(res => {
        if (res.data.resultCode === '0') {
          this.vendorList = res.data.resultData.vendorList || []
        }
      })
    },

    budgetTypeChange () {
      this.approvalFormData.trCode = ''
      this.approvalFormData.quotaId = ''
    },

    // 获取普通预算
    getBudgetList () {
      const params = {
        quotaType: '01'
      }
      this.$store.dispatch('getBudgetList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.budgetList = res.data.resultData.quotaDetailList
        }
      })
    },

    // 获取TR预算
    getTrList () {
      const params = {
        applyId: this.applyId
      }
      this.$store.dispatch('getTrList', params).then(res => {
        if (res.data.resultCode === '0') {
          this.trList = res.data.resultData.quotaList
        }
      })
    },

    trChange (val) {
      if (!val) {
        return
      }
      this.approvalFormData.trCode = val
      // this.approvalFormData.quotaId = val
      // this.trList.forEach(item => {
      //   if (item.quotaId === val) {
      //     this.approvalFormData.trCode = item.trKhCode
      //   }
      // })
    },

    // 获取MMR12
    getMmrList () {
      this.$store.dispatch('getMmrList').then(res => {
        if (res.data.resultCode === '0') {
          this.mmrList = res.data.resultData.baseMmr12List
        }
      })
    },

    mmr12Change () {
      this.ledgerList = []
      this.approvalFormData.ledgerAccount = ''
      if (!this.approvalFormData.mmr12) {
        return
      }
      this.getLedgerList()
    },

    // 获取总账科目
    getLedgerList () {
      this.$store.dispatch('getLedgerList', this.approvalFormData.mmr12).then(res => {
        if (res.data.resultCode === '0') {
          this.ledgerList = res.data.resultData.ledgerList
        }
      })
    },

    // 获取工厂
    async getCompanyList (vendorCode) {
      const { data } = await this.$store.dispatch('getCompanyList', { vendorCode })
      if (data.resultCode === '0') {
        this.companyList = data.resultData.companyEntityList || []
        this.companyList.forEach(item => {
          const title = `${item.entityCode}-${item.entityName}`
          this.$set(item, 'title', title)
        })
      }
    },

    // 选择工厂
    handleCompanyChange() {
      this.costList = []
      this.approvalFormData.costCenterCode = ''
      if (this.approvalFormData.companyEntityCode) {
        this.getCostList()
      }
    },

    // 获取成本中心
    getCostList () {
      const { companyEntityCode } = this.approvalFormData
      this.$store.dispatch('getCostList', { companyEntityCode }).then(res => {
        if (res.data.resultCode === '0') {
          this.costList = res.data.resultData.baseCostCenterList
        }
      })
    },

    /** 待审批订单批量驳回 */
    handleBatchReject () {
      this.$emit('handleBatchConfirm')
    },

    /** 待审批订单批量通过 */
    handleBatchPass () {
      this.$emit('handleBatchConfirm')
    },
    thousandSymbol (value) {
      if (value === 0) {
        return 0
      }
      if (!value) {
        return
      }
      let num = value.toString().split('.')
      let resultNum = num[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      if (num[1]) {
        resultNum = resultNum + '.' + num[1]
      }
      return resultNum
    },
    sliceOrgName (val) {
      if (!val) {
        return
      }
      let res = val.split('|')[0]
      return res
    }

  }
}
</script>
<style lang="scss" scoped>
.block-radio {
  .el-radio {
    margin-right: 20px;
    margin-left: 20px;
  }

  ::v-deep .el-radio .el-radio__input {
    display: inline-block;
  }

  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: $base-red;
    background: $base-red;
  }

  ::v-deep .el-radio__inner:hover {
    border-color: $base-red;
  }
}

.content-row {
  line-height: 42px;

  .el-col-3 {
    text-align: right;
    margin-right: 15px;
  }
}

.content-remark {
  margin-top: 10px;
  line-height: 20px;
}
</style>
